<template>
  <div class="edit-page content-430">
    <div class="class-form-divide">
      <div class="class-form-head">套餐信息</div>
      <ComBaseInfo
        ref="comBaseInfoRef"
        :detail-info="detailInfo"
        :productPackageId="productPackageId"
      ></ComBaseInfo>
      <ComSettingInfo
        ref="comSettingInfo"
        :detail-info="detailInfo"
      ></ComSettingInfo>
    </div>
    <div class="formbtnbox-430-bottom">
      <Button
        type="primary"
        :loading="isSaveing"
        :disabled="isSaveing"
        @click="checkAllForm(1)"
        >保存</Button
      >
      <Button @click="handleGoBack">取消</Button>
    </div>
  </div>
</template>

<script>
import ComBaseInfo from './components/ComBaseInfo';
import ComSettingInfo from './components/ComSettingInfo';
import courseCenter from '@/request/courseCenter/index.js';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "courseCenterCommodityEditCombo",
  components: {
    ComBaseInfo,
    ComSettingInfo
  },
  data() {
    return {
      productPackageId: '',
      detailInfo: null,
      isSaveing: false,
      portOrg: Number(localStorage.getItem('portOrg'))
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST', 'SET_CACHEROUTE', 'DELETE_CACHEROUTE'
    ]),
    init() {
      this.productPackageId = this.$route.query.id;
      if (this.productPackageId) {
        this.getProductPackageDetail(this.productPackageId);
      }
    },
    handleGoBack() {
      this.CLOSE_BROWSINGHISTORYLIST(this.$route.name)
      if (!this.productPackageId) {
        this.DELETE_CACHEROUTE('courseCenterCommodityComboTable')
      }
      this.$router.push({
        path: `/courseCenter/commodity/comboTable`
      });
    },
    async checkAllForm() {
      await this.$refs.comBaseInfoRef.handleCheckSubmit();

      await this.$refs.comSettingInfo.handleCheckSubmit();

      if (this.productPackageId) {
        this.updateProductPackage();
      } else {
        this.saveProductPackage();
      }
    },
    // 获取套餐详情
    async getProductPackageDetail(productPackageId) {
      this.$Spin.show();
      const res = await courseCenter.getProductPackageDetail({ productPackageId });
      this.$Spin.hide();
      if (res.status == 200) {
        this.detailInfo = res.message;
      }
    },
    // 编辑套餐
    async updateProductPackage() {

      const baseInfoPt = await this.$refs.comBaseInfoRef.getParameter();
      const settingInfoPt = await this.$refs.comSettingInfo.getParameter();
      const parameter = { productPackageId: this.productPackageId, ...baseInfoPt, ...settingInfoPt };
      if (parameter.gradeMin > parameter.gradeMax) {
        parameter.gradeMin = baseInfoPt.gradeMax;
        parameter.gradeMax = baseInfoPt.gradeMin;
      }
      const filte = ['productPackageId', 'comboSelOptionList', 'courseCover', 'packageName', 'classroomFee', 'gradeMin', 'gradeMax', 'enrollTimeBegin', 'enrollTimeEnd', 'classroomState', 'packageDesc', 'refundDeadLine', 'enableRefund', 'refundConfig', 'isLimitEnroll', 'visibleDtoList'];

      for (const k in parameter) {
        console.log(k, !filte.includes(k))
        if (!filte.includes(k)) {
          delete parameter[k];
        }
      }
      this.isSaveing = true;
      this.$Spin.show();
      let res;
      if (this.portOrg == 2) {
        res = await courseCenter.updateProductPackageBySch(parameter);
      } else {
        res = await courseCenter.updateProductPackage(parameter);
      }
      //

      this.isSaveing = false;
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success('编辑成功');
        //  this.SET_CACHEROUTE([]);
        this.handleGoBack();
      }
    },
    // 添加套餐
    async saveProductPackage() {

      const baseInfoPt = await this.$refs.comBaseInfoRef.getParameter();
      const settingInfoPt = await this.$refs.comSettingInfo.getParameter();
      const parameter = { ...baseInfoPt, ...settingInfoPt };

      this.isSaveing = true;
      this.$Spin.show();
      let res;
      if (this.portOrg == 2) {
        res = await courseCenter.saveProductPackageBySch(parameter);
      } else {
        res = await courseCenter.saveProductPackage(parameter);
      }

      this.$Spin.hide();
      this.isSaveing = false;
      if (res.status == 200) {
        // this.SET_CACHEROUTE([]);
        this.$Message.success('添加成功');
        this.handleGoBack();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-page {
  padding-bottom: 150px !important;
}
.formbtnbox-430-bottom {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 -4px 2px rgba(0, 0, 0, 0.03);
  padding: 16px 0;

  button + button {
    margin-left: 16px;
  }
}
</style>
